import React from 'react'
import { useSelector } from 'react-redux'

const Account = () => {
    let data=useSelector((state)=>{
        return state
    })
    console.log(data);
  return (
    <div className='container'>
        <h1 className='text-primary'>ACCOUNT DETAILS</h1>
    <table style={{border:"2px solid"}}>
        <thead style={{border:"2px solid"}}>
            <tr style={{border:"2px solid"}}>
                <th style={{border:"2px solid"}}>BALANCE</th>
                <th style={{border:"2px solid"}}>USER NAME</th>
                <th style={{border:"2px solid"}}>MOBILE NUMBER</th>
            </tr>
        </thead>
        <tbody>
            <tr style={{border:"2px solid"}}>
                <th style={{border:"2px solid"}}>{data.account.balance}</th>
                <th style={{border:"2px solid"}}>{data.account.fullName}</th>
                <th style={{border:"2px solid"}}>{data.account.mobile}</th>
            </tr>
        </tbody>
    </table><br /><br />
    <h2 className='text-primary'>TRANSACTION DETAILS</h2>
    <table style={{border:"2px solid"}}>
        <thead style={{border:"2px solid"}}>
            <tr style={{border:"2px solid"}}>
            <th style={{border:"2px solid"}}>ID</th>
                <th style={{border:"2px solid"}}>AMOUNT</th>
                <th style={{border:"2px solid"}}>TYPE(DEBIT/CREDIT)</th>
                <th style={{border:"2px solid"}}>DATE</th>
            </tr>
        </thead>
        <tbody>
               {
                data.transaction.map((tr,index)=>{
                    console.log(tr);
                    return(
                        <>
                            <tr key={tr.id} style={{border:"2px solid"}}>
                                <td style={{border:"2px solid"}}>{tr.id}</td>
                                <td style={{border:"2px solid"}}>{tr.amount}</td>
                                <td style={{border:"2px solid"}}>{tr.type}</td>
                                <td style={{border:"2px solid"}}>{tr.date.toString()}</td>
                            </tr>
                        </>
                    )
                })
               }
        </tbody>
    </table>
    </div>
  )
}

export default Account